import styled from '@emotion/styled';

import COLOR from '../../../../../shared/constant/colorset';

import { NoMainImageLogo } from '../../../../../shared/images';

const ProductThumb = styled.div<{ thumbUrl: string; }>`
  width: 430px;
  height: 552px;
  background: url(${(props) => (props.thumbUrl)}), url(${NoMainImageLogo}) no-repeat 50% 50%;
  background-size: cover, contain;
  background-color: ${COLOR.kurlyGray150};
`;

interface Props {
  mainImageUrl: string;
}

export default function MainImage({ mainImageUrl }: Props) {
  return (
    <ProductThumb
      thumbUrl={mainImageUrl}
    />
  );
}
